document.addEventListener('DOMContentLoaded', ()=>{
  const AnchorsLinks = document.querySelectorAll(".byob_anchors[data-section]");
  window.addEventListener("scroll", event => {
  const fromTop = window.scrollY,
        headerOffset = (document.querySelector(".section-header").clientHeight || 0) + document.querySelector(".byob_ctaAnchorsContainer").clientHeight;
        AnchorsLinks.forEach(link => {
          if (link.dataset.section == null) return;
          const section = document.querySelector(`[data-anchor="${link.dataset.section}"]`);
          if (section) {
            if (section.offsetTop - headerOffset <= fromTop && section.offsetTop + section.clientHeight - headerOffset > fromTop) {
              link.classList.add("active");
              const htab_container = document.querySelector('.byob_ctaAnchorsList');
              const htab_tabRect = link.getBoundingClientRect();
              const htab_containerRect = htab_container.getBoundingClientRect();
              const scrollLeft = htab_container.scrollLeft + (htab_tabRect.left - htab_containerRect.left) - (htab_containerRect.width / 2 - htab_tabRect.width / 2);
              htab_container.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
              });
            }else{
              link.classList.remove("active");
            }
          }
        })
  });
  document.querySelectorAll('.byob_anchors').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      let sectionTarget = target.currentTarget.dataset.section;
      if (sectionTarget){
        var targetElement = document.querySelector(`[data-anchor="${sectionTarget}"]`);
        window.scrollTo({
          top: targetElement.offsetTop - document.querySelector('.section-header').clientHeight - document.querySelector('.byob_ctaAnchorsContainer').clientHeight,
          behavior: 'smooth'
        });        
      }
    })
  });

  const HtmlAppendDrawer = (image,title,price,compare,normal_price,normal_cprice,subscription_price,subscription_cprice,variant_id,selling_id,serving,benifit) =>{
   let benefitHtml = benifit?.innerHTML || "";
   let HardestHtml =  `<div class="Byob_itemsList" data-mapped-handle="${title}" data-mapped-price="${normal_price}" data-mapped-cprice="${normal_cprice}" data-mapped-subscription-price="${subscription_price}" data-mapped-subscription-cprice="${subscription_cprice}" data-mapped-variant-id="${variant_id}"  data-mapped-selling-id="${selling_id}">
      <div class="Byob_image_drawer"><img src="${image}&amp;width=520"></div>
      <div class="Byob_content_drawer">
        <div class="Byob_title_priceContainer">
          <div class="Byob_title_drawer">${title}</div>
          <div class="Byob_price_drawerMn">
            <span class="Byob_price_drawer">${price}</span>
            <span class="Byob_cprice_drawer">${compare}</span>
          </div>
        </div>
        <div class="Byob_servingRemoveContainer">
          <div class="Byob_serving_drawer">${serving}</div>
          <div class="Byob_remove_drawer"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"> <path d="M5.16497 16.625C4.83841 16.625 4.55885 16.5087 4.3263 16.2762C4.09375 16.0436 3.97747 15.7641 3.97747 15.4375V4.15625H3.16602V2.96875H6.88685V2.375H12.1118V2.96875H15.8327V4.15625H15.0212V15.4375C15.0212 15.7542 14.9025 16.0312 14.665 16.2688C14.4275 16.5062 14.1504 16.625 13.8337 16.625H5.16497ZM13.8337 4.15625H5.16497V15.4375H13.8337V4.15625ZM7.26289 13.7354H8.45039V5.83854H7.26289V13.7354ZM10.5483 13.7354H11.7358V5.83854H10.5483V13.7354Z" fill="#797B7A"></path> </svg></div>
        </div>
        <div class="Byob__form-title"><div class="byob_bannerKeyPoints">${benefitHtml}</div></div>
      </div>
    </div>`
    if ( document.querySelector('.ByobListedDrawerWp').childElementCount != 9 ){
        document.querySelector('.ByobListedDrawerWp').innerHTML = document.querySelector('.ByobListedDrawerWp').innerHTML + HardestHtml;
        document.querySelector('.Byob_drawerSlider').classList.add('active');
    }   
    let ELementCount = document.querySelector('.ByobListedDrawerWp').childElementCount;
    if( ELementCount == 9 ){
      document.querySelectorAll('.ItemnsLeftDrawer').forEach((elm)=>{ 
        elm.querySelector('.itemsCount').innerHTML = `9/9 Items Selected`;
        elm.querySelector('.ItemsDrawerList').querySelector('span').style.width = `100%`;
      });
      document.querySelector('.ItemsCountLength').classList.add('hidden');
      document.querySelector('.ItemsChoosedOneWay').innerHTML = `9/9 Items Selected`;
      HTMLMobiledrawerOpen();
    }else{
      document.querySelector('.ItemsCountLength').classList.remove('hidden');
      document.querySelectorAll('.ItemnsLeftDrawer').forEach((elm)=>{ 
        elm.querySelector('.itemsCount').innerHTML = `${ELementCount}/9 Items Selected`;
        elm.querySelector('.ItemsDrawerList').querySelector('span').style.width = `${parseFloat(11.11*ELementCount)}%`;
      });   
      if( ELementCount == 8 ){
        document.querySelector('.ItemsCountLength span').innerHTML = `Add ${parseInt(9) - parseInt(ELementCount)} more items to complete bundle`;
      }else{
        document.querySelector('.ItemsCountLength span').innerHTML = `Add ${parseInt(9) - parseInt(ELementCount)} more item to complete bundle`;
      }
      document.querySelector('.ItemsChoosedOneWay').innerHTML = `${ELementCount}/9 Items Selected`;
    }
  }

  const HTMLPriceUpdate = ()=>{
    if( document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ){
      document.querySelectorAll(`[data-productsubscripiton-price]`).forEach((target)=>{
        let PriceSubscriptionEach = target.dataset.productsubscripitonPrice;
        target.querySelector('.Byob__price-recurring').innerHTML = PriceSubscriptionEach;
      });
      document.querySelectorAll(`[data-productsubscripiton-cprice]`).forEach((target)=>{
        let CPriceSubscriptionEach = target.dataset.productsubscripitonCprice;
        target.querySelector('.Byob__price-otp').innerHTML = CPriceSubscriptionEach;
      });
      document.querySelectorAll(`[data-mapped-subscription-price]`).forEach((target)=>{
        let PriceSubscriptionEachD = target.dataset.mappedSubscriptionPrice;
        target.querySelector('.Byob_price_drawer').innerHTML = PriceSubscriptionEachD;
      });
      document.querySelectorAll(`[data-mapped-subscription-cprice]`).forEach((target)=>{
        let CPriceSubscriptionEachD = target.dataset.mappedSubscriptionCprice;
        target.querySelector('.Byob_cprice_drawer').innerHTML = CPriceSubscriptionEachD;
      });        
    }else{
      document.querySelectorAll(`[data-product-price]`).forEach((target)=>{
        let PriceOneTimeEach = target.dataset.productPrice;
        target.querySelector('.Byob__price-recurring').innerHTML = PriceOneTimeEach;
      });
      document.querySelectorAll(`[data-product-cprice]`).forEach((target)=>{
        let CPriceOneTimeEach = target.dataset.productCprice;
        target.querySelector('.Byob__price-otp').innerHTML = CPriceOneTimeEach;
      });
      document.querySelectorAll(`[data-mapped-price]`).forEach((target)=>{
        let PriceOneTimeEachD = target.dataset.mappedPrice;
        target.querySelector('.Byob_price_drawer').innerHTML = PriceOneTimeEachD;
      });
      document.querySelectorAll(`[data-mapped-cprice]`).forEach((target)=>{
        let CPriceOneTimeEachD = target.dataset.mappedCprice;
        target.querySelector('.Byob_cprice_drawer').innerHTML = CPriceOneTimeEachD;
      })       
    }  
  }

  const PriceCountTotal = ()=>{
    let TotalSumPriceOneTime = 0,
        TotalSumCPriceOneTime = 0,
        TotalSumPriceSubscription = 0,
        TotalSumCPriceSubscription = 0,
        PriceOneTimeTotal,
        CPriceOneTimeTotal,
        PriceSubscriptionTotal,
        CPriceSubscriptionTotal;
    PriceOneTimeTotal = Array.from(document.querySelectorAll('[data-mapped-price]'), (price) => price.dataset.mappedPrice);
    CPriceOneTimeTotal = Array.from(document.querySelectorAll('[data-mapped-cprice]'), (price) => price.dataset.mappedCprice);
    PriceSubscriptionTotal = Array.from(document.querySelectorAll('[data-mapped-subscription-price]'), (price) => price.dataset.mappedSubscriptionPrice)
    CPriceSubscriptionTotal = Array.from(document.querySelectorAll('[data-mapped-subscription-cprice]'), (price) => price.dataset.mappedSubscriptionCprice);
    for (let i = 0; i < PriceOneTimeTotal.length; i++) {
      let PriceGet = PriceOneTimeTotal[i].replace(/\$/g, '');
      TotalSumPriceOneTime += parseFloat(PriceGet);
    }
    for (let i = 0; i < CPriceOneTimeTotal.length; i++) {
      let PriceGet = CPriceOneTimeTotal[i].replace(/\$/g, '');
      TotalSumCPriceOneTime += parseFloat(PriceGet);
    } 
    for (let i = 0; i < PriceSubscriptionTotal.length; i++) {
      let PriceGet = PriceSubscriptionTotal[i].replace(/\$/g, '');
      TotalSumPriceSubscription += parseFloat(PriceGet);
    } 
    for (let i = 0; i < CPriceSubscriptionTotal.length; i++) {
      let PriceGet = CPriceSubscriptionTotal[i].replace(/\$/g, '');
      TotalSumCPriceSubscription += parseFloat(PriceGet);
    }     
    let FinalizeSummaryCart = document.querySelector('.ByobListedDrawerWp').childElementCount;
    let CountLeftFinaize = parseInt(9) - parseInt(FinalizeSummaryCart);
    if( FinalizeSummaryCart == 9 ){

      const isSubscription = document.querySelector('[name="purchaseType"]:checked').value === 'purchaseTypeSubscription';
      const priceSub = isNaN(TotalSumPriceSubscription) ? '' : `$${TotalSumPriceSubscription.toFixed(2)}`;
      const comparePriceSub = isNaN(TotalSumCPriceOneTime) ? '' : `<s>$${TotalSumCPriceOneTime.toFixed(2)}</s>`;
      const priceOneTime = isNaN(TotalSumPriceOneTime) ? '' : `$${TotalSumPriceOneTime.toFixed(2)}`;
      const comparePriceOneTime = isNaN(TotalSumCPriceOneTime) ? '' : `<s>$${TotalSumCPriceOneTime.toFixed(2)}</s>`;
      const html = isSubscription
        ? `<span>Add Bundle To Cart —&nbsp;</span> <span>${priceSub}</span> ${comparePriceSub}`
        : `<span>Add Bundle To Cart —&nbsp;</span> <span>${priceOneTime}</span> ${comparePriceOneTime}`;
      document.querySelector('.PurchaseActionBuoyBtn button .ButtonLayoutFlex').innerHTML = html;
      
      document.querySelector('[js-onetimeprice]').innerHTML = `${priceOneTime}`;
      document.querySelector('[js-onetimecprice]').innerHTML = `${comparePriceOneTime}`;
      document.querySelector('[js-subscriptionprice]').innerHTML = `${priceSub}`;
      document.querySelector('[js-subscriptioncprice]').innerHTML = `${comparePriceSub}`;      
    }else if( FinalizeSummaryCart == 8 ){
      document.querySelector('.PurchaseActionBuoyBtn button .ButtonLayoutFlex').innerHTML = `<span>Add ${CountLeftFinaize} more item</span>`
      document.querySelector('[js-onetimeprice]').innerHTML = ``;
      document.querySelector('[js-onetimecprice]').innerHTML = ``;
      document.querySelector('[js-subscriptionprice]').innerHTML = ``;
      document.querySelector('[js-subscriptioncprice]').innerHTML = ``;      
    }else{
      document.querySelector('.PurchaseActionBuoyBtn button .ButtonLayoutFlex').innerHTML = `<span>Add ${CountLeftFinaize} more items</span>`
      document.querySelector('[js-onetimeprice]').innerHTML = ``;
      document.querySelector('[js-onetimecprice]').innerHTML = ``;
      document.querySelector('[js-subscriptionprice]').innerHTML = ``;
      document.querySelector('[js-subscriptioncprice]').innerHTML = ``;      
    }   
  }  

  const HTMLRemoved = ()=>{
    document.querySelectorAll('.Byob_remove_drawer').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        let RemovedOne = target.target.closest('.Byob_itemsList').dataset.mappedHandle;
        let QtyRemoved = parseInt(document.querySelector(`[data-product-title="${RemovedOne}"]`).querySelector('.digitSelector').textContent);
        if ( QtyRemoved == 1){
          document.querySelector(`[data-product-title="${RemovedOne}"]`).querySelector('.Byob_Buttongrouped').classList.remove('active');
        }else{
          QtyRemoved = parseInt(QtyRemoved) - parseInt(1);
          document.querySelector(`[data-product-title="${RemovedOne}"]`).querySelector('.digitSelector').innerHTML = QtyRemoved;
        }
        target.target.closest('.Byob_itemsList').remove();
        let ELementCountRm = document.querySelector('.ByobListedDrawerWp').childElementCount;
        document.querySelectorAll('.ItemnsLeftDrawer').forEach((elm)=>{ 
          elm.querySelector('.itemsCount').innerHTML = `${ELementCountRm}/9 Items Selected`;
          elm.querySelector('.ItemsDrawerList').querySelector('span').style.width = `${parseFloat(11.11*ELementCountRm)}%`;
        });
        document.querySelector('.ItemsChoosedOneWay').innerHTML = `${ELementCountRm}/9 Items Selected`;
        if( ELementCountRm == 8 ){
          document.querySelector('.ItemsCountLength span').innerHTML = `Add ${parseInt(9) - parseInt(ELementCountRm)} more items to complete bundle`;
        }else{
          document.querySelector('.ItemsCountLength span').innerHTML = `Add ${parseInt(9) - parseInt(ELementCountRm)} more item to complete bundle`;
        }        
        document.querySelector('.ItemsCountLength').classList.remove('hidden');
        PriceCountTotal();AddingButtonQA();
      })
    });
  } 

  const AddingButtonQA = ()=>{
    let HowManyProductsCount = document.querySelector('.ByobListedDrawerWp').childElementCount;
    if( HowManyProductsCount == 9 ){
      document.querySelector(`[js-main-button]`).disabled = false;
    }else{
      document.querySelector(`[js-main-button]`).disabled = true;
    }
  }

  const getGuid = ()=> {
      let d = new Date().getTime();
      let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          let r = Math.random() * 16;
          if (d > 0) {
              r = (d + r) % 16 | 0;
              d = Math.floor(d / 16);
          } else {
              r = (d2 + r) % 16 | 0;
              d2 = Math.floor(d2 / 16);
          }
          return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
      }); 
  }

  const getDynamicBoxId = async (productPlatformId) => {
    try {
      const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productPlatformId: productPlatformId 
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`); 
      }
      
      const data = await response.json();
      return data.DynamicBox?.boxId || null;
    } catch (error) {
      console.error('Error fetching dynamic box ID:', error);
      return null;
    } 
  }

  const calculateDynamicBoxIndex = async (dynamicBoxId) => {
    if (!dynamicBoxId) return 0;
    
    try {
      // Get current cart contents
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Find all items with the same dynamicBoxId and get their indices
      const existingIndices = [];
      cart.items.forEach(item => {
        if (item.properties && item.properties._dynamicBoxId === dynamicBoxId) {
          const index = parseInt(item.properties._dynamicBoxIndex);
          if (!isNaN(index)) {
            existingIndices.push(index);
          }
        }
      });
      
      // Return the next available index
      if (existingIndices.length === 0) { 
        return 0; // First occurrence
      }
      
      // Find the highest existing index and increment by 1
      const maxIndex = Math.max(...existingIndices);
      return maxIndex + 1;
      
    } catch (error) {
      console.error('Error calculating dynamic box index:', error);
      return 0; // Fallback to 0 if cart fetch fails
    }
  }

  const FinalizeBundleProducts = async ()=>{
    if( document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ){
    let JsonFormat,
        Gvid,
        Gvslid,
        uniqID = new Date().getTime().toString(),
        bundleID = getGuid(),
        ProductCount = 0,
        bundleContainer = document.querySelector('.Byob_containerLayout'),
        bundleProductID = bundleContainer.dataset.bundleMainId,
        bundleProductSellingId = bundleContainer.dataset.sellingPlan,
        bundleProductPlatformId = bundleContainer.dataset.bundleProductId,
        bundleCart = {
          'items': []
        },        
        mainProperties = {
          _bundle_id: bundleID,
          _bundle_parent: "true",
          _uniq_id:uniqID
        };      

      let cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) document.querySelector("cart-drawer").enableLoading();
      
      // Get dynamic box ID from Skio API
      const dynamicBoxId = bundleProductPlatformId ? await getDynamicBoxId(bundleProductPlatformId) : null;
      
      // Calculate dynamic box index by checking existing cart for same dynamicBoxId
      const dynamicBoxIndex = await calculateDynamicBoxIndex(dynamicBoxId);
      
      document.querySelectorAll(`[data-mapped-variant-id]`).forEach((vid)=>{
        ProductCount++;
        Gvid = parseInt(vid.dataset.mappedVariantId);
        Gvslid = parseInt(vid.dataset.mappedSellingId);
        
        JsonFormat = {id: Gvid,selling_plan:Gvslid,quantity:1,properties: { _bundle_id: bundleID, _dynamicBoxId: dynamicBoxId, _dynamicBoxIndex: dynamicBoxIndex, _original_qty: 1, _uniq_id:uniqID }};
        
        bundleCart.items.push(JsonFormat);
      });
      
      // Note: _dynamicBoxId and _dynamicBoxIndex are only added to individual bundle items, not the parent

      // let cartItem = {
      //   id: bundleProductID,
      //   quantity: 1,
      //   selling_plan:bundleProductSellingId,
      //   properties:mainProperties
      // };

      // bundleCart.items.push(cartItem);
      bundleCart.sections = cartDrawer.getSectionsToRender().map((section) => section.section);
      bundleCart.sections_url = window.location.pathname      
    
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(bundleCart),
          credentials: 'same-origin'
      }).then((response) => response.json())
      .then((parsedState) => {
        cartDrawer.renderContent(parsedState.sections);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector(`[js-main-button]`).classList.remove('processingBundle');
        if (cartDrawer) {
          document.querySelector("cart-drawer").disableLoading();
          document.querySelector("cart-drawer").open();
        }
        HTMLMobiledrawerOpen();clearSummaryDrawerAfterAdd();
      }); 

    }else{
      let JsonFormat,
          Gvid,
          Gvslid,
          uniqID = new Date().getTime().toString(),
          bundleID = getGuid(),
          ProductCount = 0,
          bundleContainer = document.querySelector('.Byob_containerLayout'),
          bundleProductID = bundleContainer.dataset.bundleMainId,
          bundleProductSellingId = bundleContainer.dataset.sellingPlan,
          bundleProductPlatformId = bundleContainer.dataset.bundleProductId,
          bundleCart = {
            'items': []
          },        
          mainProperties = {
            _bundle_id: bundleID,
            _bundle_parent: "true",
            _uniq_id:uniqID
          };      
  
        let cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) document.querySelector("cart-drawer").enableLoading();
        
        // Get dynamic box ID from Skio API for one-time purchase
        const dynamicBoxId = bundleProductPlatformId ? await getDynamicBoxId(bundleProductPlatformId) : null;
        
        // Calculate dynamic box index by checking existing cart for same dynamicBoxId
        const dynamicBoxIndex = await calculateDynamicBoxIndex(dynamicBoxId);
        
        document.querySelectorAll(`[data-mapped-variant-id]`).forEach((vid)=>{
          ProductCount++;
          Gvid = parseInt(vid.dataset.mappedVariantId);
          Gvslid = parseInt(vid.dataset.mappedSellingId);
          JsonFormat = {id: Gvid,quantity:1,properties: { _bundle_id: bundleID, _dynamicBoxId: dynamicBoxId, _dynamicBoxIndex: dynamicBoxIndex, _original_qty: 1, _uniq_id:uniqID }};
          
          bundleCart.items.push(JsonFormat);
        });
        
        // Note: _dynamicBoxId and _dynamicBoxIndex are only added to individual bundle items, not the parent

        // let cartItem = {
        //   id: bundleProductID,
        //   quantity: 1,
        //   properties:mainProperties
        // };  
  
        // bundleCart.items.push(cartItem);
        bundleCart.sections = cartDrawer.getSectionsToRender().map((section) => section.section);
        bundleCart.sections_url = window.location.pathname      
      
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(bundleCart),
            credentials: 'same-origin'
        }).then((response) => response.json())
        .then((parsedState) => {
          cartDrawer.renderContent(parsedState.sections);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          document.querySelector(`[js-main-button]`).classList.remove('processingBundle');
          if (cartDrawer) {
            document.querySelector("cart-drawer").disableLoading();
            document.querySelector("cart-drawer").open();
          }
          HTMLMobiledrawerOpen();clearSummaryDrawerAfterAdd();
        }); 
    }
  }  

  const HTMLMobiledrawerOpen = ()=>{
    document.body.classList.toggle('mobile_drawerVisible');
    document.querySelector('.BuoySummaryWp').innerHTML === `Collapse` ? (document.querySelector('.BuoySummaryWp').innerHTML = `Summary`) : (document.querySelector('.BuoySummaryWp').innerHTML = `Collapse`);
  }
  const SummaryDrawerMobileAnimation = ()=>{
    document.querySelector('.BuoyMb__bar').classList.add('bounceTwo');
    setTimeout(()=>{ document.querySelector('.BuoyMb__bar').classList.remove('bounceTwo'); },1500);
  }  

  const clearSummaryDrawerAfterAdd = ()=>{
    document.querySelector('.ByobListedDrawerWp').innerHTML = ``;
    document.querySelector('.ItemsCountLength').querySelector('span').innerHTML = `Add 9 more items to complete bundle`;
    document.querySelectorAll('.ItemnsLeftDrawer').forEach((elm)=>{ elm.querySelector('.itemsCount').innerHTML = `0/9 Items Selected`; elm.querySelector('.ItemsDrawerList').querySelector('span').removeAttribute('style') });
    document.querySelector('[js-onetimeprice]').innerHTML = ``;
    document.querySelector('[js-onetimecprice]').innerHTML = ``;
    document.querySelector('[js-subscriptionprice]').innerHTML = ``;
    document.querySelector('[js-subscriptioncprice]').innerHTML = ``;
    document.querySelector('[js-main-button]').disabled = true;
    document.querySelector('[js-main-button]').querySelector('.ButtonLayoutFlex').innerHTML = `<span>Add 9 more items</span>`;
    document.querySelectorAll('.Byob_Buttongrouped').forEach((elm)=>{
      elm.querySelector('.Byob_containerQty').querySelector('.ByobSelectorQty').querySelector('.digitSelector').innerHTML = `${parseInt(1)}`;
      elm.classList.remove('active');
    });
    document.querySelector('.ItemsChoosedOneWay').innerHTML = `0/9 Items Selected`;
  }  

  document.querySelectorAll('.Byob_actionbtn').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      let mg,tt,pp,cp,nprice,ncprice,subprice,subcprice,variantID,SellingID,servingProcess,benifitsQ;
      let RemainingNowAdd = document.querySelector('.ByobListedDrawerWp').childElementCount;
      if( RemainingNowAdd == 9 ){}else{ 
        target.target.closest('.Byob_Buttongrouped').classList.add('active');
        mg = document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ? (target.target.closest('.Byob_productGrid').dataset.productImage) : (target.target.closest('.Byob_productGrid').dataset.productImage);
        tt = document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ? (target.target.closest('.Byob_productGrid').dataset.productTitle) : (target.target.closest('.Byob_productGrid').dataset.productTitle);
        pp = document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ? (target.target.closest('.Byob_productGrid').dataset.productsubscripitonPrice) : (target.target.closest('.Byob_productGrid').dataset.productPrice);
        cp = document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ? (target.target.closest('.Byob_productGrid').dataset.productsubscripitonCprice) : (target.target.closest('.Byob_productGrid').dataset.productCprice);
        nprice = target.target.closest('.Byob_productGrid').dataset.productPrice;
        ncprice = target.target.closest('.Byob_productGrid').dataset.productCprice;
        subprice = target.target.closest('.Byob_productGrid').dataset.productsubscripitonPrice;
        subcprice = target.target.closest('.Byob_productGrid').dataset.productsubscripitonCprice;
        variantID = target.target.closest('.Byob_productGrid').dataset.productVariantId;
        SellingID = target.target.closest('.Byob_productGrid').dataset.productSellingId;
        servingProcess = target.target.closest('.Byob_productGrid').dataset.servingProcess;
        if( target.target.closest('.Byob_productGrid').querySelector('.byob_bannerKeyPoints') ){
          benifitsQ = target.target.closest('.Byob_productGrid').querySelector('.byob_bannerKeyPoints');
        }        
        HtmlAppendDrawer(mg,tt,pp,cp,nprice,ncprice,subprice,subcprice,variantID,SellingID,servingProcess,benifitsQ);HTMLRemoved();PriceCountTotal();AddingButtonQA();SummaryDrawerMobileAnimation();        
      }
    });
  });

  document.querySelectorAll('.Byob_qtyMaster.plusIcon').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      let mgPQ,ttPQ,ppPQ,cpPQ,npricePQ,ncpricePQ,subpricePQ,subcpricePQ,variantIDPQ,SellingIDPQ,servingProcessPQ,benifits;
      let CurrentQty = target.target.closest('.ByobSelectorQty').querySelector('.digitSelector').textContent;
      let RemainingNow = document.querySelector('.ByobListedDrawerWp').childElementCount;
      if( RemainingNow == 9 ){}else{
        CurrentQty = parseInt(CurrentQty) + parseInt(1);
        target.target.closest('.ByobSelectorQty').querySelector('.digitSelector').innerHTML = CurrentQty;
        mgPQ = document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ? (target.target.closest('.Byob_productGrid').dataset.productImage) : (target.target.closest('.Byob_productGrid').dataset.productImage);
        ttPQ = document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ? (target.target.closest('.Byob_productGrid').dataset.productTitle) : (target.target.closest('.Byob_productGrid').dataset.productTitle);
        ppPQ = document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ? (target.target.closest('.Byob_productGrid').dataset.productsubscripitonPrice) : (target.target.closest('.Byob_productGrid').dataset.productPrice);
        cpPQ = document.querySelector('[name="purchaseType"]:checked').value == 'purchaseTypeSubscription' ? (target.target.closest('.Byob_productGrid').dataset.productsubscripitonCprice) : (target.target.closest('.Byob_productGrid').dataset.productCprice);      
        npricePQ = target.target.closest('.Byob_productGrid').dataset.productPrice;
        ncpricePQ = target.target.closest('.Byob_productGrid').dataset.productCprice;
        subpricePQ = target.target.closest('.Byob_productGrid').dataset.productsubscripitonPrice;
        subcpricePQ = target.target.closest('.Byob_productGrid').dataset.productsubscripitonCprice;
        variantIDPQ = target.target.closest('.Byob_productGrid').dataset.productVariantId;
        SellingIDPQ = target.target.closest('.Byob_productGrid').dataset.productSellingId; 
        servingProcessPQ = target.target.closest('.Byob_productGrid').dataset.servingProcess;
        if( target.target.closest('.Byob_productGrid').querySelector('.byob_bannerKeyPoints') ){
          benifits = target.target.closest('.Byob_productGrid').querySelector('.byob_bannerKeyPoints');
        }
        HtmlAppendDrawer(mgPQ,ttPQ,ppPQ,cpPQ,npricePQ,ncpricePQ,subpricePQ,subcpricePQ,variantIDPQ,SellingIDPQ,servingProcessPQ,benifits);HTMLRemoved();PriceCountTotal();AddingButtonQA();SummaryDrawerMobileAnimation();
      }
    });
  }); 

  document.querySelectorAll('.Byob_qtyMaster.minusIcon').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      let CurrentQty = parseInt(target.target.closest('.ByobSelectorQty').querySelector('.digitSelector').textContent);
      if ( CurrentQty > 1 ){
        CurrentQty = parseInt(CurrentQty) - parseInt(1); 
        target.target.closest('.ByobSelectorQty').querySelector('.digitSelector').innerHTML = CurrentQty;
        let removed = target.target.closest('.Byob_productGrid').dataset.productTitle;
        document.querySelector(`[data-mapped-handle="${removed}"]`).remove();
        let RemainingElement = document.querySelector('.ByobListedDrawerWp').childElementCount;
        document.querySelectorAll('.ItemnsLeftDrawer').forEach((elm)=>{  elm.querySelector('.itemsCount').innerHTML = `${RemainingElement}/9 Items Selected`; elm.querySelector('.ItemsDrawerList').querySelector('span').style.width = `${parseFloat(11.11*RemainingElement)}%` });
        document.querySelector('.ItemsChoosedOneWay').innerHTML = `${RemainingElement}/9 Items Selected`;
        if( RemainingElement == 8 ){
          document.querySelector('.ItemsCountLength span').innerHTML = `Add ${parseInt(9) - parseInt(RemainingElement)} more items to complete bundle`;
        }else{
          document.querySelector('.ItemsCountLength span').innerHTML = `Add ${parseInt(9) - parseInt(RemainingElement)} more item to complete bundle`;
        }         
        document.querySelector('.ItemsCountLength').classList.remove('hidden');
        HTMLRemoved();PriceCountTotal();AddingButtonQA();
      }else{
        target.target.closest('.Byob_Buttongrouped').classList.remove('active');
        let removed = target.target.closest('.Byob_productGrid').dataset.productTitle;
        document.querySelector(`[data-mapped-handle="${removed}"]`).remove();
        let RemainingElement = document.querySelector('.ByobListedDrawerWp').childElementCount;
        document.querySelectorAll('.ItemnsLeftDrawer').forEach((elm)=>{ 
          elm.querySelector('.itemsCount').innerHTML = `${RemainingElement}/9 Items Selected`;
          elm.querySelector('.ItemsDrawerList').querySelector('span').style.width = `${parseFloat(11.11*RemainingElement)}%`;
        });        
        document.querySelector('.ItemsChoosedOneWay').innerHTML = `${RemainingElement}/9 Items Selected`;
        if( RemainingElement == 8 ){
          document.querySelector('.ItemsCountLength span').innerHTML = `Add ${parseInt(9) - parseInt(RemainingElement)} more items to complete bundle`;
        }else{
          document.querySelector('.ItemsCountLength span').innerHTML = `Add ${parseInt(9) - parseInt(RemainingElement)} more item to complete bundle`;
        }         
        document.querySelector('.ItemsCountLength').classList.remove('hidden');
        HTMLRemoved();PriceCountTotal();AddingButtonQA();
      }
    });
  });   

  document.querySelectorAll(`[name="purchaseType"]`).forEach((elm)=>{
    elm.addEventListener('change', (target)=>{
      target.preventDefault();
      PriceCountTotal();HTMLPriceUpdate();AddingButtonQA();
    })
  });
  
  document.querySelector(`[js-main-button]`).addEventListener('click', async (button)=>{
    button.preventDefault();
    button.currentTarget.classList.add('processingBundle');
    await FinalizeBundleProducts();
  });
  
  document.querySelectorAll(`.BuoyStickyBottomMobile`).forEach((elm)=>{
    elm.addEventListener('click',(mb_drawer)=>{
      mb_drawer.preventDefault();
      HTMLMobiledrawerOpen();
    })  
   });
  
  document.querySelectorAll(`.ItemsCountLength`).forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      HTMLMobiledrawerOpen();
    })
  });     

})